export { default } from './MainMenu';


// WEBPACK FOOTER //
// ./src/components/MainMenu/index.ts